import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CampaignTypeEnumm, IGoogleSearchAddress, ITEM_STATUS_TYPE, ITEM_TYPE_ENUM, ItemListingType, ItemListingTypeEnum, POST_ITEM_SUBHEADINGS, POST_ITEM_TYPE, PreventLeadingSpaceDirective,NumericInputDirective } from '@sml/utility';
import { RadioButtonComponent } from '@sml/radio-button';
import { IconsComponent } from '@sml/icons';
import { TextEditorComponent } from '@sml/text-editor';
import { SearchDropdownComponent } from '@sml/dropdown';
import { GooglePlacesAutocompleteComponent } from '@sml/forms';
@Component({
  selector: 'sml-item-basic-detail',
  imports: [CommonModule, ReactiveFormsModule, RadioButtonComponent, IconsComponent, TextEditorComponent, PreventLeadingSpaceDirective, SearchDropdownComponent,GooglePlacesAutocompleteComponent,NumericInputDirective],
  templateUrl: './item-basic-detail.component.html',
})
export class ItemBasicDetailComponent implements OnChanges {  

  @Input() form!: FormGroup;
  @Input() listingTypeId?: ItemListingType = ItemListingTypeEnum.Single;
  @Input() isFromCommunityStories = false;
  @Input() isVolunteerActivity = false;
  @Input() campaignType!: number;
  @Input() isDonated = false;
  campaignStatus = CampaignTypeEnumm;
  
  public itemTypes: { label: string; value: number }[] = [];
  public itemTypesVolunteer: { label: string; value: number }[] = [];
  public itemStatusType = ITEM_STATUS_TYPE;
  // public itemPostType = POST_ITEM_TYPE;
  // public itemPostSubHeadings = POST_ITEM_SUBHEADINGS;

  constructor() {
    this.initializeItemTypes();
  }

  ngOnChanges() {
    this.initializeItemTypes();
    
    if (this.listingTypeId === ItemListingTypeEnum.Custom) {
      this.form.get('typeId')?.disable();
    }
    
    if (this.itemTypes?.length === 1) {
      this.form.get('typeId')?.setValue(this.itemTypes[0].value);
    }
    
    if (this.isVolunteerActivity) {
      if (this.itemTypesVolunteer?.length > 0) {
        this.form.get('typeId')?.setValue(this.itemTypesVolunteer[0].value);
      }
    }
  }

  private initializeItemTypes() {
    // Get all item types
    const allItemTypes = Object.entries(ITEM_TYPE_ENUM)
      .filter(([key, value]) => !isNaN(Number(value)))
      .map(([key, value]) => ({
        label: key,
        value: Number(value)
      }));

    // Filter based on campaign type
    switch (this.campaignType) {
      case CampaignTypeEnumm['Memorial Program']:
        this.itemTypes = allItemTypes.filter(item => item.value === ITEM_TYPE_ENUM['Memorial Item']);
        break;
      
      case CampaignTypeEnumm['Sponsorship']:
        this.itemTypes = allItemTypes.filter(item => item.value === ITEM_TYPE_ENUM['Sponsorship']);
        break;
      
      case CampaignTypeEnumm['Fundraiser']:
        this.itemTypes = allItemTypes.filter(item => item.value === ITEM_TYPE_ENUM['Monetary Gift']);
        break;
      
      case CampaignTypeEnumm['Registration']:
        this.itemTypes = allItemTypes.filter(item => item.value === ITEM_TYPE_ENUM['Registration']);
        break;
      
      case CampaignTypeEnumm['Volunteer Activity']:
        this.itemTypes = allItemTypes.filter(item => item.value === ITEM_TYPE_ENUM['Volunteer Activity']);
        this.itemTypesVolunteer = [...this.itemTypes];
        break;
      
      case CampaignTypeEnumm['Interactive Tour']:
        this.itemTypes = [
              ITEM_TYPE_ENUM['Historical Marker'],
              ITEM_TYPE_ENUM['Honoree'],
              ITEM_TYPE_ENUM['Memorial Item'],
              ITEM_TYPE_ENUM['Person'],
              ITEM_TYPE_ENUM['Point of Interest'],
              ITEM_TYPE_ENUM['Public Art'],
              ITEM_TYPE_ENUM['Other'],
         ].map(value => ({ label: ITEM_TYPE_ENUM[value], value }));
        break; 
      default:
        this.itemTypes = [
         ITEM_TYPE_ENUM['Event'],
         ITEM_TYPE_ENUM['Historical Marker'],
         ITEM_TYPE_ENUM['Honoree'],
         ITEM_TYPE_ENUM['Memorial Item'],
         ITEM_TYPE_ENUM['Monetary Gift'],
         ITEM_TYPE_ENUM['Person'],
         ITEM_TYPE_ENUM['Point of Interest'],
         ITEM_TYPE_ENUM['Public Art'],
         ITEM_TYPE_ENUM['Registration'],
         ITEM_TYPE_ENUM['Sponsorship'],
         ITEM_TYPE_ENUM['Volunteer Activity'],
         ITEM_TYPE_ENUM['Other']
        ].map(value => ({ label: ITEM_TYPE_ENUM[value], value }));
        break;
    }
  }

  get control() {
    return this.form.controls;
  }

  onControlTouched() {
    this.control['typeId'].markAsTouched();
    this.control['typeId'].updateValueAndValidity();
  }
  onControlDirty() {
    this.control['typeId'].markAsDirty();
    this.control['typeId'].updateValueAndValidity();
  }


  // get disabledOptions(): ITEM_STATUS_TYPE[]{
  //   if(this.isFromCommunityStories) {
  //     return [ITEM_STATUS_TYPE.Available];
  //   }
  //   else if(this.listingTypeId !== ItemListingTypeEnum.Single) {
  //     if(this.control['statusId'].value === ITEM_STATUS_TYPE.Donated) {
  //       return [ITEM_STATUS_TYPE.Available, ITEM_STATUS_TYPE.Donated];
  //     }
  //     return [ITEM_STATUS_TYPE.Donated];
  //   }
  //   return [];
  // }
  
    onPlaceSelected(place: IGoogleSearchAddress) {
      this.control['address'].patchValue(place.formattedAddress);
      this.control['longitude'].patchValue(place.long ?? this.control['longitude'].value);
      this.control['latitude'].patchValue(place.lat ?? this.control['latitude'].value);
      
    }
}
